import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconChevronRight = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fillRule: "evenodd", d: "M8.543 19.207a1 1 0 0 1 0-1.414L14.336 12 8.543 6.207a1 1 0 0 1 1.414-1.414l5.793 5.793a2 2 0 0 1 0 2.828l-5.793 5.793a1 1 0 0 1-1.414 0", clipRule: "evenodd" }) })));
};
//# sourceMappingURL=IconChevronRight.js.map